module.exports = __webpack_public_path__ + "img/icon_tab_favorite.48653eff.png";